import AppContext from "@casino/legacy/shared/context/AppContext";
import { useContext } from "react";

const useAppContext = () => useContext(AppContext);

export default useAppContext;
